<template>
  <div id="app-main" class="data-list">
    <el-container>
      <div class="corner corner1" />
      <div class="corner corner2" />
      <div class="corner corner3" />
      <div class="corner corner4" />
      <el-aside width="300px">
        <SideBanner />
      </el-aside>
      <el-main>
        <el-table :data="resourceList" size="medium">
          <el-table-column type="index" :index="(pageNum - 1) * pageSize + 1" label="序号" width="80" align="center" />
          <!-- <el-table-column prop="resourceId" label="ID" width="120" align="center" /> -->
          <el-table-column prop="title" label="题名" align="left" />
          <el-table-column label="类型" width="200" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.type | mapType }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="分类" width="150" align="center">
            <template slot-scope="scope">
              <span>{{ formatCategory(scope.row.category) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <router-link :to="{ name: 'ResourceInfo', params: { resId: scope.row.resourceId } }" target="_blank">
                <el-button type="primary" size="small" plain icon="el-icon-reading">查看</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          :total="total"
          :current-page="pageNum"
          :page-size="pageSize"
          :page-sizes="[15, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          background
          @current-change="handlePageNumChange"
          @size-change="handlePageSizeChange"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideBanner from '@/components/SideBanner'
// 接口
import { resourceList } from '@/api/ResourceApi'
// 资源类型常量
import { typeName } from '@/constants/ResourceType'

import { mapGetters } from 'vuex'

export default {
  name: 'ResourceList',
  components: {
    SideBanner
  },
  filters: {
    mapType(type) {
      return typeName[type]
    }
  },
  data() {
    return {
      type: this.$route.query.type,
      category: this.$route.query.cat,
      resourceList: [],
      // 分页信息
      pageNum: 1,
      pageSize: 15,
      total: 0
    }
  },
  computed: {
    ...mapGetters(['navType', 'categoryList'])

  },

  beforeRouteUpdate(to, from, next) {
    this.type = to.query.type
    this.category = to.query.cat
    this.pageNum = 1
    this.fetchResourceList()
    next()
  },
  created() {
    this.fetchResourceList()
  },
  methods: {
    formatCategory(cid) {
      console.log('cid:', cid)
      const category = this.categoryList.find((item) => item.id === cid)
      return category === undefined ? '未知分类' : category.title
    },
    fetchResourceList() {
      const params = {
        page: this.pageNum,
        limit: this.pageSize,
        category: this.category
      }
      if (this.navType === 'siku') {
        params.siku = this.type
      } else {
        params.type = this.type
      }
      resourceList(params).then((resp) => {
        this.resourceList = resp.page.list
        this.total = resp.page.totalCount
      })
    },

    handleView(resourceId) {
      this.$router.push({ name: 'ResourceInfo', params: { resId: resourceId }})
    },

    handlePageNumChange(pageNum) {
      this.pageNum = pageNum
      this.fetchResourceList()
      this.$nextTick(() => {
        window.scrollTo({
          top: 135,
          behavior: 'smooth'
        })
      })
    },
    handlePageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.fetchResourceList()
    }
  }
}
</script>

<style lang="scss" scoped>
#app-main {
  min-height: 800px;
  width: 1200px;
  margin: 0 auto;
}

.el-container {
  background: url(../../assets/imgs/block-bg.png);
  padding: 9px;
  border: 1px solid #d5d5d4;
  width: 1200px;
  min-height: 800px;
  margin-bottom: 30px;
  position: relative;
  left: 0px;
  top: 0px;
  // 四个角方块
  .corner {
    width: 12px;
    height: 12px;
    border: 1px solid #d5d5d4;
    position: absolute;
  }
  // 方块1
  .corner1 {
    top: -6px;
    left: -6px;
  }
  // 方块2
  .corner2 {
    top: -6px;
    right: -6px;
  }
  // 方块3
  .corner3 {
    bottom: -6px;
    left: -6px;
  }
  // 方块4
  .corner4 {
    right: -6px;
    bottom: -6px;
  }
}

.el-aside {
  overflow: hidden;
  height: 100%;
}

//数据列表
.el-main {
  border: 1px solid #d6d5d5;
  padding: 10px 0 10px 10px;
  margin-left: 20px;
  background-color: #fff;
}

.el-table {
  // 主体
  background-size: 100% 99%;
  padding: 15px;
  // 表头
  ::v-deep th {
    background-color: #fff;
    color: #222;
    font-size: 16px;
    font-family: Microsoft Yahei;
  }

  // 数据列表
  ::v-deep tr {
    background-color: rgba(255, 255, 255, 1);
    font-size: 14px;
  }
}

.el-pagination {
  margin-top: 15px;
  .el-pager {
    .active {
      background-color: #8d7351;
    }
  }
}
</style>
